import React from 'react';
import { Container, Typography } from '@mui/material';

const Dispersals: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1">
        Group Dispersal Requests
      </Typography>
      {/* Implement group dispersal requests */}
    </Container>
  );
};

export default Dispersals;
